.tiktok-page .topbar { display: flex; flex-wrap: wrap; gap: 8px 24px; justify-content: space-between; }
.discord-nav { flex-wrap: wrap; }
.tiktok-page .tool-control-title { margin: 0; font-size: 19px; font-weight: 600; line-height: 1.3; }
.tiktok-browse { justify-self: center; color: var(--violet); padding: 12px; text-underline-offset: 4px; }
.tiktok-example-group { display: grid; gap: 20px; }
.tiktok-example-group + .tiktok-example-group { margin-top: 28px; }
.tiktok-page .tiktok-bio-text { display: flex; align-items: center; justify-content: center; min-height: 130px; margin: 0; padding: 22px 16px; background: #f4efff; border-radius: 10px; color: #51465e; text-align: center; font-size: 17px; line-height: 1.7; overflow-wrap: anywhere; user-select: text; }
.tiktok-example-group:nth-of-type(2) .tiktok-bio-text { background: #fff0f5; }
.tiktok-card-actions { display: flex; gap: 8px; }
.tiktok-card-actions button { flex: 1; min-height: 44px; border: 1px solid #ddd3ed; border-radius: 8px; background: white; color: #6542a6; font: inherit; font-size: 14px; cursor: pointer; }
.tiktok-card-actions button:last-child { background: #f4efff; }
.tiktok-card-actions button:hover { background: #e9dfff; }
.tiktok-card-actions button:focus-visible { outline: 2px solid #8050dd; outline-offset: 3px; }
.tiktok-copy-status { font-size: 13px; color: #6542a6; }
.tiktok-copy-status:empty { display: none; }
.tiktok-guide h3 { margin: 0 0 12px; font-size: 20px; line-height: 1.4; }
.tiktok-guide p { margin: 0; color: #68657c; line-height: 1.8; }
@media (max-width: 700px) {
  .tiktok-page .tool-control-title { font-size: 17px; }
  .tiktok-page .discord-nav { gap: 4px 16px; font-size: 12px; }
}

.tiktok-page .css-action-label::before { content: attr(data-label); }
